
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { StylistBlogService } from '../../../services/StylistBlogService';

function useBlogViewHook(t) {
  const params = useParams();
  let id = params.blog_id;
  const navigate = useNavigate();
  const image_url = process.env.REACT_APP_MEDIA_DOMAIN;
  const [data, setData] = useState("");
  const [loader,setLoader]=useState(false);

  useEffect(() => {
    StylistBlogService.ViewBlog(id)
      .then((data) => {
        setLoader(true);
        setData(data.data);
      })
      .catch((error) => 
      {
        console.log("Errorreg", error);
        setLoader(false);
      });
  }, []);

  return {
    data, image_url,loader,navigate
  }
}

export default useBlogViewHook